import { onInitService } from "./init-service";
export { Gate } from "./containers/Gate";

export const serviceGates = ({ registerTargets }) => {
  registerTargets({
    ONE_GATE: "one/gate/main",
    ONE_GATE_LOADING: "one/gate/loading",
    ONE_GATE_ERROR: "one/gate/error",
    ONE_GATE_PUBLIC: "one/gate/public",
    ONE_GATE_AUTH: "one/gate/auth",
    ONE_GATE_EMBED: "one/gate/embed",
    ONE_GATE_SHELL: "one/gate/shell"
  });

  return [
    {
      target: "$INIT_SERVICE",
      handler: onInitService
    }
  ];
};
